module.exports = __webpack_public_path__ + "img/6.cf4e1fcc.jpg";